export default "__VITE_ASSET__Cqr9xCC3__"